import React from "react";

import { AxiomTooltipNew } from "../AxiomTooltip/AxiomTooltip.jsx";

import { Utils } from "./Utils.js";

import "./AxiomBarChartTable.scss";

export default class AxiomBarChartTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollLevel: 1,
      rowCount: this.props.rowCount ? this.props.rowCount : 30,
      isDrillDownRequired: props.isDrillDownRequired != null ? props.isDrillDownRequired : true,
    };
  }

  componentDidMount() {
    $(".AxiomBarChartScrollable").addClass("activeScroll");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.rowCount != this.props.rowCount) {
      this.setState({
        rowCount: this.props.rowCount,
      });
    }
  }

  onTableScroll = (e) => {
    let table = $("#" + e.target.id);
    let eTableTop = table.offset().top; //get the offset top of the element
    let ab = $(table).scrollTop() + $(table).innerHeight() >= $(table)[0].scrollHeight;
    if (ab) this.setState({ scrollLevel: this.state.scrollLevel + 1 });
  };

  render() {
    const { barChartData } = this.props;

    return (
      <div
        id={this.props.id}
        onScroll={this.onTableScroll}
        className="AxiomBarChartScrollable"
        style={{
          minHeight: (this.props.height - 44 < 0 ? 0 : this.props.height - 44) + "px",
          maxHeight: (this.props.height - 44 < 0 ? 0 : this.props.height - 44) + "px",
          //minWidth: this.props.columnData.length * 200 + "px"
        }}
      >
        <div className="AxiomBarChartTable">
          {barChartData
            .slice(
              0,
              this.state.scrollLevel * this.state.rowCount <= barChartData.length
                ? this.state.scrollLevel * this.state.rowCount
                : barChartData.length
            )
            .map((item, i) => {
              return (
                <AxiomTooltipNew
                  key={i}
                  place="top"
                  tooltip={
                    this.props.tooltipShow && (
                      <table className="AxiomBarChartTooltipContainer">
                        <tbody>
                          {this.props.columnData.map((colData, index) => {
                            return (
                              <tr key={i + "_" + index}>
                                <td className="AxiomBarChartTooltipKey">
                                  {colData.tooltipDisplayName}
                                </td>
                                <td className="AxiomBarChartTooltipValue">
                                  {colData.format
                                    ? Utils.apply_format(
                                        item[colData.col].text,
                                        colData.format,
                                        colData.unit
                                      )
                                    : item[colData.col].text}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )
                  }
                >
                  <div
                    className={
                      "AxiomBarChartView_TableBodyRow" +
                      (this.props.arrFilterData &&
                      this.props.selectedCol &&
                      this.props.arrFilterData
                        .filter((d) => {
                          return this.props.columnData[0].displayName == d.key;
                        })
                        .map((d) => {
                          return d.text;
                        })
                        .indexOf(item[this.props.selectedCol].text) != -1
                        ? " AxiomBarChartView_TableBodyRowSelected"
                        : "")
                    }
                    style={{ height: this.props.rowHeight || "28px" }}
                    key={i}
                  >
                    {this.props.columnData.map((colData, index) => {
                      var data = item[colData.col];
                      const additionalStyles = {};
                      if (data.number != null && data.barCenterPointPercent != null) {
                        additionalStyles.left = `${data.barCenterPointPercent}%`;
                        additionalStyles.width = `${Math.abs(data.number)}%`;
                        if (data.number < 0) {
                          additionalStyles.transform = "rotate(-180deg)";
                          additionalStyles.transformOrigin = "left center";
                        }
                      }
                      const progressStyle = {
                        width:
                          data.number == null
                            ? data.absoluteNumber == null
                              ? "100%"
                              : data.absoluteNumber + "px"
                            : data.number + "%",
                        background: data.background == null ? null : data.background,
                        height: data.height
                          ? data.height == null
                            ? "100%"
                            : data.height + "px"
                          : "100%",
                        top: data.height == null ? 0 : "calc(50% - " + data.height / 2 + "px)",
                        ...additionalStyles,
                      };
                      const valueStyle = {
                        "--cell-text-align": colData.textAlign
                          ? colData.textAlign
                          : data.textAlign
                          ? data.textAlign
                          : "left",
                        "--cell-text-color": data.textColor ? data.textColor : "inherit",
                      };
                      let titleText = colData.format
                        ? Utils.apply_format(parseFloat(data.text), colData.format, colData.unit)
                        : data.text;
                      if (colData.titleDisplayColumns != null) {
                        titleText =
                          (colData.titlePrefix || "") +
                          data[colData.titleDisplayColumns] +
                          (colData.titlePostfix || "");
                      }
                      return (
                        <div
                          onClick={() =>
                            this.props.addToDrillDown
                              ? this.props.addToDrillDown(item, colData)
                              : null
                          }
                          className={`AxiomBarChartView_TableBodyItem ${
                            this.state.isDrillDownRequired
                              ? "AxiomBarChartView_TableBodySelectable"
                              : ""
                          }`}
                          style={colData.style && colData.style}
                          key={index}
                        >
                          <div
                            className={
                              "AxiomBarChartView_Bar " +
                              (data.className == null ? "" : data.className)
                            }
                          >
                            {data.number != null ||
                            (data.absoluteNumber != null && data.height != null) ? (
                              <div className={"AxiomBarChartView_Bar_ProgressTrack"}>
                                <div
                                  style={progressStyle}
                                  className={"AxiomBarChartView_Bar_ProgressFill"}
                                />
                              </div>
                            ) : null}
                            <div
                              style={valueStyle}
                              title={titleText}
                              className={
                                "AxiomBarChartViewValue" +
                                (data.number != null ? " AxiomBarChartViewValue_Fill" : "")
                              }
                            >
                              {data.number == null ? (
                                <span>
                                  {colData.format
                                    ? Utils.apply_format(
                                        parseFloat(data.text),
                                        colData.format,
                                        colData.unit
                                      )
                                    : data.text}
                                </span>
                              ) : (
                                <span>
                                  {colData.format
                                    ? Utils.apply_format(
                                        parseFloat(data.text),
                                        colData.format,
                                        colData.unit
                                      )
                                    : data.text}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </AxiomTooltipNew>
              );
            })}
        </div>
      </div>
    );
  }
}
